import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

export default function GridContainer(props) {
    return (
        <div className={twMerge(
            'sm:max-w-8xl mx-auto z-10 grid grid-cols-12 gap-x-6 gap-y-6 relative',
            props.footerSpacing,
            props.className
        )}>
            {props.children}
        </div>
    );
}